import { simulatorAPI } from '../../../services/api';

/** @type {import('./simulatorRawTechMapping').TechMappingRow[] | null} */
let cachedMappings = null;
/** @type {Promise<import('./simulatorRawTechMapping').TechMappingRow[] | null> | null} */
let inflight = null;

/**
 * Load mapping table (cached after first success). Returns null on failure.
 * @returns {Promise<import('./simulatorRawTechMapping').TechMappingRow[] | null>}
 */
export function ensureSimulatorTechMappingLoaded() {
  if (cachedMappings) {
    return Promise.resolve(cachedMappings);
  }
  if (!inflight) {
    inflight = simulatorAPI
      .getTechMapping()
      .then((res) => {
        if (res?.success && Array.isArray(res.mappings) && res.mappings.length > 0) {
          cachedMappings = res.mappings;
          return cachedMappings;
        }
        return null;
      })
      .catch(() => null)
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
}

/** Prefetch on simulator mount so raw URLs do not wait unnecessarily. */
export function prefetchSimulatorTechMapping() {
  return ensureSimulatorTechMappingLoaded();
}
